import { AxiosResponse } from "axios";
import { ICreateInvoiceRequest, IInvoice, IListInvoicesResult } from "./types";
import { apiInstance } from "../base";

export const createInvoice = (data: ICreateInvoiceRequest): Promise<AxiosResponse<IInvoice>> => {
    return apiInstance.handler.post<IInvoice>(`/invoices`, data)
} 

export const cancelInvoice = (id: number): Promise<AxiosResponse<void>> => {
    return apiInstance.handler.post<void>(`/invoices/${id}/cancel`)
} 

export const listInvoices = (page: number, limit: number): Promise<AxiosResponse<IListInvoicesResult>> => {
    return apiInstance.handler.get<IListInvoicesResult>(`/invoices`, {
        params: {
            page,
            limit
        }
    })
} 

export const getInvoicePdf = (id: number): Promise<AxiosResponse> => {
    return apiInstance.handler.get(`/invoices/${id}`, {
        responseType: 'blob',
        headers: {
            'Content-Type': 'application/pdf',
        },
    })
}